const initials = (name, email) =>
  (name || email || "?").split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0].toUpperCase()).join("");

export function ProfileAvatar({ profile, className = "h-20 w-20 text-2xl", testId = "profile-avatar" }) {
  if (profile.profile_photo_url) {
    return <img src={profile.profile_photo_url} alt={profile.full_name || "Profile photo"} data-testid={testId} className={`${className} shrink-0 rounded-md object-cover`} />;
  }
  return (
    <span data-testid={testId} className={`${className} flex shrink-0 items-center justify-center rounded-md border border-border bg-muted font-serif text-foreground/70`}>
      {initials(profile.full_name, profile.email)}
    </span>
  );
}
